<sepidz-review [hasIncludeTime]="true" class="review" *ngIf="hasPermission">
  <div review-filters class="filters">
    <div class="listbox">
      <div class="titleheader" *ngIf="isMultiBranch">
        <div class="title" (click)="setSelectedFilter('Branch')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.CostsSpentReview.Branch" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'Branch'"></i>
        </div>
        <div *ngIf="selected === 'Branch'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.CostsSpentReview.Branch' | translate"
            [form]="formGroup"
            name="Branch"
            key="BranchIds"
            apiName="Branch/ReadLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('CostsCategory')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.CostsSpentReview.CostsCategory" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'CostsCategory'"></i>
        </div>
        <div *ngIf="selected === 'CostsCategory'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.CostsSpentReview.CostsCategory' | translate"
            [form]="formGroup"
            name="CostsCategory"
            key="CostsCategoryIds"
            apiName="CostGroup/ReadLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('Costs')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.CostsSpentReview.Costs" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'Costs'"></i>
        </div>
        <div *ngIf="selected === 'Costs'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.CostsSpentReview.Costs' | translate"
            [form]="formGroup"
            name="Costs"
            key="CostsIds"
            apiName="Cost/ReadLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
    </div>
  </div>
  <div review-content>
    <ssg-tabset class="tabset" (tabChange)="selectTab($event)">
      <ssg-tab
        *hasPermission="['RestaurantSale:CostsSpentReview/CostsSpentList', 'Same']"
        [tabTitle]="'ClientApp.FrontOffice.Review.CostsSpentReview.CostsSpent' | translate">
        <ng-container *ngIf="isActveTab('ClientApp.FrontOffice.Review.CostsSpentReview.CostsSpent' | translate)">
          <sepidz-grid-review
            *ngIf="GetCostsSpentListColumns?.length > 0 && isActveTab('ClientApp.FrontOffice.Review.CostsSpentReview.CostsSpent' | translate)"
            name="CostsSpentList"
            [title]="'ClientApp.FrontOffice.Review.CostsSpentReview.CostsSpent' | translate"
            apiName="CostsSpentReview/CostsSpentList"
            areaName="RestaurantSale"
            [groupable]="false"
            [columns]="GetCostsSpentListColumns"
            [filtering]="true"
            pathPreFix="SALE"
            displayNameColumn="Code"
            key="CostsSpentIds"
            aggregatesColumnName="Amount">
          </sepidz-grid-review>
        </ng-container>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['RestaurantSale:CostsSpentReview/TotalCostsByDateList', 'Same']"
        [tabTitle]="'ClientApp.FrontOffice.Review.CostsSpentReview.TotalCostsByDate' | translate">
        <ng-container *ngIf="isActveTab('ClientApp.FrontOffice.Review.CostsSpentReview.TotalCostsByDate' | translate)">
          <sepidz-grid-review
            *ngIf="
              GetTotalCostsListByDateColumns?.length > 0 && isActveTab('ClientApp.FrontOffice.Review.CostsSpentReview.TotalCostsByDate' | translate)
            "
            name="TotalCostsByDateList"
            [title]="'ClientApp.FrontOffice.Review.CostsSpentReview.TotalCostsByDate' | translate"
            apiName="CostsSpentReview/TotalCostsByDateList"
            areaName="RestaurantSale"
            [groupable]="false"
            [columns]="GetTotalCostsListByDateColumns"
            [filtering]="true"
            pathPreFix="SALE"
            displayNameColumn="ShamsiDate"
            key="TotalCostsIds"
            aggregatesColumnName="Amount, Count">
          </sepidz-grid-review>
        </ng-container>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['RestaurantSale:CostsSpentReview/CostsCategoryList', 'Same']"
        [tabTitle]="'ClientApp.FrontOffice.Review.CostsSpentReview.CostsCategory' | translate">
        <ng-container *ngIf="isActveTab('ClientApp.FrontOffice.Review.CostsSpentReview.CostsCategory' | translate)">
          <sepidz-grid-review
            *ngIf="GetCostsCategoryListColumns?.length > 0 && isActveTab('ClientApp.FrontOffice.Review.CostsSpentReview.CostsCategory' | translate)"
            name="CostsCategoryList"
            [title]="'ClientApp.FrontOffice.Review.CostsSpentReview.CostsCategory' | translate"
            apiName="CostsSpentReview/CostsCategoryList"
            areaName="RestaurantSale"
            [groupable]="false"
            pathPreFix="SALE"
            displayNameColumn="CostGroupTitle"
            [columns]="GetCostsCategoryListColumns"
            key="CostsCategoryIds"
            aggregatesColumnName="PriceCount, AmountSpent">
          </sepidz-grid-review>
        </ng-container>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['RestaurantSale:CostsSpentReview/CostsList', 'Same']"
        [tabTitle]="'ClientApp.FrontOffice.Review.CostsSpentReview.Costs' | translate">
        <ng-container *ngIf="isActveTab('ClientApp.FrontOffice.Review.CostsSpentReview.Costs' | translate)">
          <sepidz-grid-review
            *ngIf="GetCostsListColumns?.length > 0"
            name="CostsList"
            key="CostsIds"
            [title]="'ClientApp.FrontOffice.Review.CostsSpentReview.FactorDetail' | translate"
            apiName="CostsSpentReview/CostsList"
            areaName="RestaurantSale"
            pathPreFix="SALE"
            displayNameColumn="Code"
            [columns]="GetCostsListColumns"
            aggregatesColumnName="Amount, Count">
          </sepidz-grid-review>
        </ng-container>
      </ssg-tab>
    </ssg-tabset>
  </div>
</sepidz-review>
